<template>
  <div class="mt-1">
    <b-row class="centered">
      <b-icon-gear-fill variant="secondary" font-scale="4"></b-icon-gear-fill>
      <b-icon-gear-fill variant="secondary" font-scale="4"></b-icon-gear-fill>
      <b-icon-gear-fill variant="secondary" font-scale="4"></b-icon-gear-fill>
    </b-row>
    <h4
      class="centered"
    >We're sorry, we're not able to retrieve data from the server at the moment, please try again. If the problem persists the administator will be notified.</h4>
  </div>
</template>
<script>
import { BIconGearFill } from "bootstrap-vue";

export default {
  components: {
    BIconGearFill,
  },
};
</script>
<style scoped>
.centered {
  justify-content: center;
  display: flex;
}
</style>